import React from 'react';
import SurveyEditor from '../../components/survey/SurveyEditor';
import DocumentWorkspace from '../../components/document/DocumentWorkspace';

/**
 * Survey Editor page component
 * Uses the DocumentWorkspace shell to integrate with document management
 * 
 * @returns {JSX.Element} - Rendered component
 */
function SurveyEditorPage() {
  return (
    <div className="survey-editor-page">
      <DocumentWorkspace>
        <SurveyEditor />
      </DocumentWorkspace>
    </div>
  );
}

export default SurveyEditorPage;